import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import TemplatesContainer from './TemplatesContainer'


const TemplatesRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><TemplatesContainer></TemplatesContainer></Provider>
}

TemplatesRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default TemplatesRoot
